/* 長い一覧を短くたたむ。
   - KINNIKU TIMES の大会スケジュール：5件まで表示
   - 筋トレ最安ナビのランキング：10位まで表示
   どちらも「もっと見る」を押すと残りが開く。
   最安ナビにはもともと .is-collapsed の仕組みがあるが、
   適用されていないリストには自前の .fp-collapsed を付ける。 */
(function () {
  function button(label, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.textContent = label;
    return b;
  }

  function rankings() {
    var lists = document.querySelectorAll('ol.fpc-list, ul.fpc-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.getAttribute('data-fp-more') === '1') continue;
      if (list.classList.contains('is-collapsed')) continue;   /* 既に折りたたまれている */
      if (list.closest && list.closest('.fpc')) continue;      /* 最安ナビ本体は自前の仕組みが持つ */
      if (list.hidden || list.offsetParent === null) continue;  /* 切替で隠れている一覧には出さない */
      var n = list.children.length;
      if (n <= 10) continue;
      list.setAttribute('data-fp-more', '1');
      list.classList.add('fp-collapsed');
      var b = button('もっと見る（残り ' + (n - 10) + ' 件）', 'fp-more-btn');
      list.parentNode.insertBefore(b, list.nextSibling);
      (function (l, btn) {
        btn.addEventListener('click', function () {
          l.classList.remove('fp-collapsed');
          btn.parentNode.removeChild(btn);
        });
      })(list, b);
    }
  }

  function schedule() {
    var rows = document.querySelectorAll('.kt-cal__row');
    if (rows.length <= 5) return;
    var parent = rows[0].parentNode;
    if (parent.getAttribute('data-fp-more') === '1') return;
    parent.setAttribute('data-fp-more', '1');
    var hidden = [];
    for (var i = 5; i < rows.length; i++) {
      rows[i].classList.add('kt-cal__row--more');
      hidden.push(rows[i]);
    }
    var b = button('もっと見る（残り ' + hidden.length + ' 件）', 'kt-more-btn');
    parent.appendChild(b);
    b.addEventListener('click', function () {
      for (var j = 0; j < hidden.length; j++) hidden[j].classList.remove('kt-cal__row--more');
      b.parentNode.removeChild(b);
    });
  }

  function run() {
    try { rankings(); } catch (e) { /* noop */ }
    try { schedule(); } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* 最安ナビは読み込み後に行を差し替えることがあるので、少し後にも見る。 */
  window.addEventListener('load', function () { setTimeout(run, 800); setTimeout(run, 2500); setTimeout(run, 6000); });
})();
